import { create } from 'zustand';
import { ApiUtils, ApplicationApi, RequestStrategyEnum } from '@shared/api';

interface IApproveCreditLimitStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  approveCreditLimit: (applicationId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApproveCreditLimitStore = create<IApproveCreditLimitStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  approveCreditLimit: ApiUtils.wrapperApi(async (applicationId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.approveCreditLimit(applicationId, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
